const openButton = document.getElementById("mobileMenuOpenBtn");
const closeButton = document.getElementById("mobileMenuCloseBtn");
const mobileMenuWrapper = document.getElementById("mobileMenuBox");
const body = document.body;

openButton.addEventListener("click", () => {
    mobileMenuWrapper.style.left = "0%";
    body.style.overflow = "hidden";
    console.log(body.style.overflow);
});

closeButton.addEventListener("click", () => {
    mobileMenuWrapper.style.left = "-100%";
    body.style.overflow = "auto";
    console.log(body.style.overflow);
});

document.addEventListener("DOMContentLoaded", () => {
    const loader = document.querySelector(".as-loader");
    const loaderBox = document.querySelector(".as-loader-box");
    const productBox = document.querySelector(".as-product-box");
    const cloudImages = document.querySelectorAll(".cloude_image");

    body.style.overflowY = 'hidden'

    const hideLoader = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                loader.style.transition = "opacity 0.5s ease, visibility 0.5s ease";
                loader.style.opacity = "0";
                loader.style.visibility = "hidden";
                
                loaderBox.style.opacity = "0";
                loaderBox.style.visibility = "hidden";

                body.style.overflowY = 'auto'
                resolve();
            }, 3000);
        });
    };

    const showCloudImages = () => {
        return new Promise((resolve) => {
            cloudImages.forEach((image, index) => {
                setTimeout(() => {
                    image.classList.add("show");
                }, index * 300);
            });

            const totalAnimationTime = cloudImages.length * 300;
            setTimeout(resolve, totalAnimationTime);
        });
    };

    const showProductBox = () => {
        if (productBox) {
            productBox.classList.add("show");
        }
    };

    hideLoader()
        .then(() => showCloudImages())
        .then(() => showProductBox());
});